export default function LinkedIn({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.92"
      height="18.692"
      viewBox="0 0 18.92 18.692"
      {...props}
    >
      <path d="M.182 5.682h3.795v13.01H.182z" />
      <path d="M2.079 0a2.079 2.079 0 1 0 2.079 2.079A2.079 2.079 0 0 0 2.079 0Z" />
      <path d="M15.816 5.638a5.087 5.087 0 0 0-5.4 1.387L9.95 5.309H6.471v13.384h4.07v-7.94a2.147 2.147 0 0 1 2.147-2.147 2.147 2.147 0 0 1 2.147 2.147v7.94h4.069v-6.692s.448-5.369-3.088-6.363Z" />
    </svg>
  );
}
